module.exports = __webpack_public_path__ + "img/primary_7x3.98054016.svg";